import ordersApi from '../_orders-api.js';

export const getOrders = async ({ commit, dispatch, state }, { type, lazy }) => {
  let ordersCollection = state.orders[type];

  if (!ordersCollection.initialized || lazy) {
    let response = await dispatch('async', () => ordersApi.getOrders(ordersCollection));

    commit('setOrders', { type: ordersCollection.type, response });

    return response;
  }
}

export const filterOrders = ({ commit, dispatch }, { type, start, end, localStart, localEnd, query }) => {
  commit('filterOrders', { type, start, end, localStart, localEnd, query });
  return dispatch('getOrders', { type, lazy: false });
}

export const sortOrders = ({ commit, dispatch }, { type, sortColumn }) => {
  commit('sortOrders', { type, sortColumn });
  return dispatch('getOrders', { type, lazy: false });
}

export const getOrder = async ({ commit, dispatch }, orderId) => {
  commit('setCurrentOrder', {});
  let response = await dispatch('async', () => ordersApi.getOrder(orderId));
  commit('setCurrentOrder', response.data);
  return response;
}

export const exportToCsv = async ({ dispatch, commit }, { collection }) => {
  let response;

  if (collection.total > 5000) {
    response = await dispatch('get', collection.exportOfflineUrl);

    commit('addNotification', response.data.message);
  } else {
    response = await dispatch('async', () => ordersApi.exportToCsv(collection.exportUrl));

    dispatch('downloadFile', { response, fileName: `${collection.type}-orders.csv` });
  }

  return response;
}